import { KontoausgleichDesktop } from '@/domain/mitarbeiter/features/feiertagskonto/features/kontoausgleich/KontoausgleichDesktop';

export function FeiertagskontoContentDesktop() {
  return (
    <div>
      <KontoausgleichDesktop />
    </div>
  );
}
